import React, { useEffect, useState } from 'react';
import routes from '../../common/routes';
import { NavLink } from 'react-router-dom';
import { locale } from '../../common/localization/localizationService';

export interface IRoutePageSelectorProps {
  selectedRoute: string;
  setSelectedRoute: (route: string) => void;
}

export default function RoutePageSelector(
  props: IRoutePageSelectorProps
): JSX.Element {
  const [isMenuOpen, setMenuOpen] = useState(false);

  const closeMenu = (event: any): void => {
    if (
      event.target.className !==
      'hamburger-menu btn btn-outline-dark route-header-action'
    ) {
      setTimeout(() => {
        setMenuOpen(false);
      }, 50);
    }
  };

  useEffect(() => {
    const appElement = document.getElementById('app');
    appElement?.addEventListener('click', closeMenu);

    return () => {
      appElement?.removeEventListener('click', closeMenu);
    };
  }, []);

  return (
    <>
      <div
        className="hamburger-menu btn btn-outline-dark route-header-action"
        onClick={() => setMenuOpen(!isMenuOpen)}
      >
        &#9776;
      </div>
      {isMenuOpen && (
        <div className="menu-dropdown">
          <NavLink to={routes.routeAdminPagePath}>
            <button
              onClick={() => props.setSelectedRoute(routes.routeAdminPagePath)}
              className={
                props.selectedRoute === routes.routeAdminPagePath
                  ? 'selected'
                  : ''
              }
            >
              {locale.general._routeAdministration}
            </button>
          </NavLink>
          <NavLink to={routes.autoSequencRoute}>
            <button
              onClick={() => props.setSelectedRoute(routes.autoSequencRoute)}
              className={
                props.selectedRoute === routes.autoSequencRoute
                  ? 'selected'
                  : ''
              }
            >
              {locale.autoSequenceRoute._autosequenceRoute}
            </button>
          </NavLink>
        </div>
      )}
    </>
  );
}
